export default __webpack_public_path__ + "static/avinash-moondra-22d566c6be44b59dec9b9791ed78b61e.png";